import script from "./InputDecimal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputDecimal.vue?vue&type=script&setup=true&lang=ts"

import "./InputDecimal.vue?vue&type=style&index=0&id=ca55d6d4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3818363008/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca55d6d4"]])

export default __exports__